'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _validate = require('./validate.attribute');

var _validate2 = _interopRequireDefault(_validate);

var _format = require('./format.attribute');

var _format2 = _interopRequireDefault(_format);

var _required = require('./required.attribute');

var _required2 = _interopRequireDefault(_required);

var _reinit = require('./reinit.attribute');

var _reinit2 = _interopRequireDefault(_reinit);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

exports.default = function (attributes) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$required = _ref.required,
      required = _ref$required === undefined ? [] : _ref$required,
      _ref$field = _ref.field,
      field = _ref$field === undefined ? null : _ref$field;

  var reinitedAttributes = (0, _reinit2.default)(attributes);
  var formatted = (0, _required2.default)(reinitedAttributes, {
    required: required,
    field: field
  });
  (0, _validate2.default)(formatted, field);
  return (0, _format2.default)(formatted, field);
};